import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { BorderedImage, BorderedVideo, Empty } from 'atoms';
import { FileSvg } from 'components/icons';
import CrossButton from '../crossButton';
import { CustomPositionAbsoluteWrapper } from 'wrappers';

const template = styled.div`
  position: relative;
`;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: CustomPositionAbsoluteWrapper,
      name: "RightCloseButtonWrapper",
      displayState: () => ({ top: '-10px', right: '-8px', left: '' }),
      atoms: [
        {
          component: CrossButton,
          name: 'CloseIcon',
          displayValue: ({ }) => '',
        },
      ]
    },
    {
      component: BorderedImage,
      name: 'Image',
      displayValue: ({ src }) => src,
      displayState: ({ }) => ({ width: '43px', height: '43px' })
    },
  ]
})
